import { render } from "./NodeEmbed.vue?vue&type=template&id=48f28e23"
import script from "./NodeEmbed.vue?vue&type=script&lang=js"
export * from "./NodeEmbed.vue?vue&type=script&lang=js"
script.render = render

export default script